export const countryLanguages: Array<LanguageInfo> = [
  { code: 'CN', lang: 'zh-hans', langName: '中文', langStripe: 'zh' },
  { code: 'US', lang: 'en', langName: 'EN', langStripe: 'en' },
  // { code: 'RU', lang: 'ru', langName: 'RU', langStripe: 'ru' },
];
